import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TwCorteCultivoCamViewModel } from './unidad-inspeccion-datosbasicos.types';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CorteCultivoCamService {
    private corteCultivoEndpoint = this.baseUrl + 'api/campanias/corteCultivoCam/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getCorteById(id: number): Observable<TwCorteCultivoCamViewModel> {
        return this.http.get<TwCorteCultivoCamViewModel>(this.corteCultivoEndpoint + id);
    }

    getCortesByIdUi(idUi: number): Observable<TwCorteCultivoCamViewModel[]> {
        return this.http.get<TwCorteCultivoCamViewModel[]>(this.corteCultivoEndpoint + 'list/' + idUi);
    }

    getCortesByIdAforo(idAforo: number): Observable<TwCorteCultivoCamViewModel[]> {
        return this.http.get<TwCorteCultivoCamViewModel[]>(this.corteCultivoEndpoint + 'listByIdAforo/' + idAforo);
    }

    saveCorte(corte: TwCorteCultivoCamViewModel): Observable<any> {
        delete corte.Almacen;
        if (corte.Id) {
            return this.updateCorte(corte);
        }
        return this.createCorte(corte);
    }

    private createCorte(corte: TwCorteCultivoCamViewModel): Observable<any> {
        return this.http.post<TwCorteCultivoCamViewModel>(this.corteCultivoEndpoint, corte);
    }

    private updateCorte(corte: TwCorteCultivoCamViewModel): Observable<any> {
        return this.http.put<TwCorteCultivoCamViewModel>(this.corteCultivoEndpoint, corte);
    }

    deleteCorte(idCorte: number): Observable<any> {
        return this.http.delete<any>(this.corteCultivoEndpoint + idCorte);
    }
}
